import { debounce } from '../../scripts/helpers.js';

/**
 * Decorator for use on class methods to apply debounce on them.
 *
 * Based on Stage 3 Decorators proposal as of 2023-11: https://github.com/tc39/proposal-decorators
 *
 * @param {number} delay
 * @return {function(function, {name: string, kind: string}): function} - decorator
 */
export default function debounced(delay) {
  return (value, { name, kind }) => {
    if (kind !== 'method') {
      throw new Error(
        `Using '@debounced' decorator on '${name}' which is of kind '${kind}'. This decorator is only meant for methods.`,
      );
    }

    return debounce(value, delay);
  };
}
